module.exports = __webpack_public_path__ + "static/media/travel-prod-info-04.2b426802.png";